import { render } from "./SignupThemeInfo.vue?vue&type=template&id=453fa75e"
import script from "./SignupThemeInfo.vue?vue&type=script&lang=js"
export * from "./SignupThemeInfo.vue?vue&type=script&lang=js"

import "./SignupThemeInfo.vue?vue&type=style&index=0&id=453fa75e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__